import { render, staticRenderFns } from "./ContentRow.vue?vue&type=template&id=5b3c48e4&scoped=true"
import script from "./ContentRow.vue?vue&type=script&lang=ts"
export * from "./ContentRow.vue?vue&type=script&lang=ts"
import style0 from "./ContentRow.vue?vue&type=style&index=0&id=5b3c48e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c48e4",
  null
  
)

export default component.exports